module.exports = __webpack_public_path__ + "img/Sensor.f7975600.svg";